import { useRetrieveEventTicketTemplateQuery, useDeleteEventTicketMutation, useDeleteEventTicketTemplateMutation, useRetrieveEventTicketStatisticsQuery } from 'services/eventTickets';
import { EventTicket } from 'components/passes/eventTicket';
import { createTemplateDetails } from 'components/reusable/template';


export const EventTicketTemplateDetails = createTemplateDetails({
  TemplateRenderer: EventTicket,
  retrieveHook: useRetrieveEventTicketTemplateQuery,
  retrieveStatisticsHook: useRetrieveEventTicketStatisticsQuery,
  deletePassHook: useDeleteEventTicketMutation,
  deleteTemplateHook: useDeleteEventTicketTemplateMutation,
  baseUrl: '/event-tickets/',
  i18nNamespace: 'pass',
})